import React from "react";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { H2, P1 } from "../../styles";
import Icon from "../../../icons";

import messages from "./messages";
import { StyledIcon, Container } from "./styles";
import { IProps } from "./interfaces";

const Hello = ({ noTitle }: IProps) => (
    <Container>
        {!noTitle && (
            <H2>
                <StyledIcon>
                    <Icon.rhytName active />
                    <br />
                </StyledIcon>
                <FormattedMessage {...messages.title} />
            </H2>
        )}
        <P1 center>
            <FormattedHTMLMessage {...messages.description} />
        </P1>
    </Container>
);

export default Hello;
